// extracted by mini-css-extract-plugin
module.exports = {"target":"CustomTooltip_target__SwauJ"};